module.exports = __webpack_public_path__ + "img/myluxura-logo.dark.8c97243c.svg";